import {ChangeDetectorRef, Component, Input, OnInit, HostListener} from '@angular/core';
import {EventsService} from '../../events/events.service';
import {GlobalService} from '../../../global.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';

@Component({
  selector: 'elastic-upcoming-broadcasts',
  templateUrl: './upcoming-broadcasts.component.html',
  styleUrls: ['./upcoming-broadcasts.component.scss']
})
export class UpcomingBroadcastsComponent implements OnInit {

  @Input() upcomingBroadcasts: any;
  innerWidth: number;
  constructor(
    private eventsService: EventsService,
    private globalService: GlobalService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }



  openTwitch(url) {
    window.open(url);
  }

}
